import React from "react";

const CategorySkeleton = () => {
  return (
    <div className="row">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="col-md-3 mb-4">
          <div className="skeleton-box"></div>
        </div>
      ))}
    </div>
  );
};

export default CategorySkeleton;
